import { render, staticRenderFns } from "./orderStatusTag.vue?vue&type=template&id=d0a21f46&scoped=true"
import script from "./orderStatusTag.vue?vue&type=script&lang=js"
export * from "./orderStatusTag.vue?vue&type=script&lang=js"
import style0 from "./orderStatusTag.vue?vue&type=style&index=0&id=d0a21f46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a21f46",
  null
  
)

export default component.exports